module.exports = __webpack_public_path__ + "static/hoppys-1-f0be7a5eca176d2a3f3d1bae8c4595b8.jpg";